import React, { useState } from "react";
import { useSelector } from "react-redux";
import ToolsList from "../ToolsList";
import AddToolListItem from "../addToolListItem/AddToolListItem";
import ToolAddOrUpdatePopup from "../toolAddOrUpdatePopup/ToolAddOrUpdatePopup";
import toolActionsType from "../../../../enums/toolActionsType";

const ToolsListWithAction = ({
    sourceTypeId,
    toolLevel,
    targetGroup,
    studyGroupId = null,
    onDelete,
    actionsType = toolActionsType.dots,
    tools,
    ...toolsListProps
}) => {

    const { texts } = useSelector(state => state.translate);
    const [popupTool, setPopupTool] = useState(null);

    return (
        <>
            <ToolsList
                {...toolsListProps}
                tools={tools}
                onEdit={(tool) => setPopupTool(tool)}
                onDelete={onDelete}
                actionsType={actionsType}
                leadingItem={
                    <AddToolListItem
                        onClick={() => setPopupTool({})}
                        accessibilityDescription={texts.addToolBtn}
                    />
                }
            />
            {popupTool !== null &&
                <ToolAddOrUpdatePopup
                    tool={popupTool}
                    onClose={() => setPopupTool(null)}
                    sourceTypeId={sourceTypeId}
                    toolLevel={toolLevel}
                    targetGroup={targetGroup}
                    studyGroupId={studyGroupId}
                />
            }
        </>
    );
};

export default ToolsListWithAction;
